import localFont from 'next/font/local';

import type { FontFamilies } from './types';

const italianPlate = localFont({
  src: [
    {
      path: '../../public/fonts/ItalianPlateNo2-Demibold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../../public/fonts/ItalianPlateNo2-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/fonts/ItalianPlateNo2-Extralight.woff2',
      weight: '200',
      style: 'normal',
    },
  ],
  display: 'swap',
});

const openSans = localFont({
  src: [
    {
      path: '../../public/fonts/OpenSans-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../../public/fonts/OpenSans-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
  ],
  display: 'swap',
});

const breitlingFont = localFont({
  src: [
    {
      path: '../../public/fonts/breitling_font.otf',
      weight: 'normal',
      style: 'normal',
    },
  ],
  display: 'swap',
});

const fontFamilies: FontFamilies = {
  openSans: openSans.style.fontFamily,
  italianPlate: italianPlate.style.fontFamily,
  breitlingFont: breitlingFont.style.fontFamily,
};

export { fontFamilies };
